export const GENERAL_CONSTANTS = {
  ManageTeam: 'Manage Team',
  Workspaces: 'Workspaces',
  Settings: 'Settings',
  Continue: 'Continue',
  Integrations: 'Integrations',
};

// Default to 500MB
export const MAX_ASSET_FILE_SIZE =
  Number("2147483648") || 500 * 1024 * 1024;

// Default to 1.5GB
export const MAX_RAW_FILE_SIZE =
  Number("2147483648") || 1.5 * 1024 * 1024 * 1024;
